import { FC } from 'react'

import { useForm, Controller } from 'react-hook-form'
import styled from 'styled-components'

import InfoIcon from 'src/Assets/Svg/common/info.svg?react'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { variables } from 'src/Styled/variables'
import { AdCampaignPlacementsTypeEnum } from 'src/Redux/ad-campaignApi'

import { AdsPlacementsModalButtons } from './AdsPlacementsModalButtons'
import { AdsPlacementsRadioItem } from './AdsPlacementsRadioItem'
import { AdsPlacementsRadioItemList } from './AdsPlacementsRadioItemList'

const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
`

export const Title = styled.span`
  font-family: Segoe UI;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize20};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const SubtitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  gap: 8px;
  > svg {
    margin-top: 4px;
  }
`

const Subtitle = styled(Title)`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`

export interface VisualFormData {
  [key: string]: string | AdCampaignPlacementsTypeEnum
  placementsType: AdCampaignPlacementsTypeEnum
}

export const AdsPlacementsModalContent: FC = () => {
  const { setSearch } = useCustomSearchParams()

  const defaultValues: VisualFormData = {
    placementsType: AdCampaignPlacementsTypeEnum.Instagram,
  }

  const { control } = useForm<VisualFormData>({
    defaultValues,
  })

  const onClickSaveVisual = (): void => {
    setSearch({ modal: null })
  }

  const onClickGoBack = (): void => {
    setSearch({ modal: null })
  }

  return (
    <>
      <TitleContainer>
        <Title>Placements</Title>
        <SubtitleWrapper>
          <InfoIcon width={16} height={16} />
          <Subtitle>
            To help you get the best results, we’ve already selected Instagram
            placements (Feeds, Reels, Stories) as they’ve consistently proven to
            turn ads into real streams.
          </Subtitle>
        </SubtitleWrapper>
      </TitleContainer>

      <ContentWrapper>
        <RadioWrapper>
          <Controller
            name='placementsType'
            control={control}
            render={({ field }) => (
              <AdsPlacementsRadioItem
                checked={field.value === AdCampaignPlacementsTypeEnum.Instagram}
                title={'Instagram'}
                description={<AdsPlacementsRadioItemList />}
                onClick={() =>
                  field.onChange(AdCampaignPlacementsTypeEnum.Instagram)
                }
              />
            )}
          />

          <Controller
            name='placementsType'
            control={control}
            render={({ field }) => (
              <AdsPlacementsRadioItem
                disabled={true}
                checked={field.value === AdCampaignPlacementsTypeEnum.Facebook}
                title={'Facebook'}
                description='Not available'
                onClick={() =>
                  field.onChange(AdCampaignPlacementsTypeEnum.Facebook)
                }
              />
            )}
          />
        </RadioWrapper>
      </ContentWrapper>

      <AdsPlacementsModalButtons
        onClickSaveVisual={onClickSaveVisual}
        onClickGoBack={onClickGoBack}
      />
    </>
  )
}
